import { render, staticRenderFns } from "./TabletContent.vue?vue&type=template&id=3e1d691d&scoped=true&"
import script from "./TabletContent.vue?vue&type=script&lang=ts&"
export * from "./TabletContent.vue?vue&type=script&lang=ts&"
import style0 from "./TabletContent.vue?vue&type=style&index=0&id=3e1d691d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1d691d",
  null
  
)

export default component.exports